module.exports = __webpack_public_path__ + "8a5356e9/img/arrow-export-icon.a3345173.svg";